// 'use client' is required here: next/dynamic with ssr:false must be used inside a Client Component
// to prevent the dynamically-loaded Etilize script from executing during SSR.
'use client';

import dynamic from 'next/dynamic';
import React from 'react';

export type EtilizeScriptProps = {
  src: string;
} & Record<`data-${string}`, string>;

/**
 * Attaches an EtilizeScript to the DOM.
 */
export function EtilizeScript(props: EtilizeScriptProps) {
  return <DynamicScript {...props} />;
}

const DynamicScript = dynamic(
  () => import('./EtilizeScriptDynamic').then(mod => mod.EtilizeScriptDynamic),
  {
    ssr: false,
  }
);
